// extracted by mini-css-extract-plugin
module.exports = {"timestamp":"ErrorTimestamp_timestamp__KSB6X typography_caption-s__Pl_G9"};